import type { NumberingStyle } from '@worldathletics/types';

import {
  computePositionalNumberMap,
  type NamingNode,
} from './compute-positional-number-map';

export type { NamingNode };

/**
 * Build an `id → displayed name` map for the document tree.
 *
 * Names are ALWAYS computed positionally from each block's index among
 * its siblings, formatted by the inherited NumberingStyle. The `title`
 * field on a block is NOT a numbering source — it is reserved for an
 * optional display suffix that the renderer appends after the computed
 * name.
 *
 * Transparent blocks (the `subsection` style or an explicit `transparent`
 * flag) don't get a name and their children continue the grandparent's
 * numbering. A block's own `numberingStyle` only steers ITS children; a
 * `numberingStyle` of `'none'`/`'free'` means "children are not auto-numbered"
 * and does NOT suppress the block's own number (that is governed by its parent).
 *
 * Propagation: when a block has a positional name, that name is used as
 * the prefix for descendants — unless the block sets
 * `propagateNumbering: false`, in which case children restart from `1`.
 */
export function computeNameMap(
  tree: NamingNode[],
  rootStyle: NumberingStyle,
): Map<string, string> {
  return computePositionalNumberMap(tree, rootStyle);
}
